/**
 * Maps plant CSS class names to full WebP asset URLs (no sprite).
 * Used for sidebar buttons and grid cells.
 */

function pathToClass(key) {
  const filename = key.split('/').pop() || key;
  const name = filename.replace(/\.webp$/i, '').replace(/\.png$/i, '');
  const lower = name.toLowerCase().replace(/\s+/g, '-').replace(/\(\d+\)/g, '').replace(/-+$/, '').trim();
  if (name.includes('Swiss Chard') && !name.includes('(2)')) return 'chard';
  if (name.includes('(2)') && name.toLowerCase().includes('swiss')) return 'swiss-chard';
  return lower || name;
}

const veg = import.meta.glob('../assets/Vegetable Pictures/*.webp', { eager: true, query: '?url', import: 'default' });
const flower = import.meta.glob('../assets/Flower Pictures/*.webp', { eager: true, query: '?url', import: 'default' });

const classToUrl = {};
for (const [path, url] of Object.entries(veg)) {
  const cls = pathToClass(path);
  classToUrl[cls] = url;
}
for (const [path, url] of Object.entries(flower)) {
  const cls = pathToClass(path);
  classToUrl[cls] = url;
}
if (classToUrl['hot-pepper']) classToUrl['pepper'] = classToUrl['hot-pepper'];
if (classToUrl['chilli-pepper']) classToUrl['chili'] = classToUrl['chilli-pepper'];
if (classToUrl['fennel-']) classToUrl['fennel'] = classToUrl['fennel-'];

/**
 * @param {string} className - e.g. "carrot", "bell-pepper"
 * @returns {string|undefined} Resolved WebP URL or undefined
 */
export function getPlantImageUrl(className) {
  return classToUrl[className];
}
